module.exports = __webpack_public_path__ + "img/tuite.3390a69.png";